var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"footer"},[_c('Button',{class:[_vm.classBtn],attrs:{"id":"footer-btn"},on:{"click":_vm.handleClick}},[(_vm.showIcon && _vm.iconName)?_c('Icon',{attrs:{"name":_vm.iconName}}):_vm._e(),_c('span',[_vm._v(_vm._s(_vm.btnText))])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }